import {
  Module,
  VuexModule,
  getModule,
  Mutation,
  Action
} from 'vuex-module-decorators'
import {
  User,
  DictDataItem,
  DictList,
  LoginForm,
  DictRequest,
  DictParam,
  DicListItem,
  DictFilter
} from '@/types'
import store from '@/store'
import Axios, {
  Method,
  AxiosResponse,
  AxiosRequestConfig,
  AxiosError,
  AxiosBasicCredentials,
  ResponseType,
  Canceler
} from 'axios'
import CryptoJS from 'crypto-js'
import { baseURL, storeGet, storePut } from './functions'
import moment from 'moment'

export interface EPL {
  baseurl: string,
  versionfg: string,
  versionbg: string,
  isAuth: boolean,
  loading: number,
  user: User,
  dicts: DictDataItem[],
  lists: DictList[],
  queue: Array<string>,
  errormessage: string,
  logstring: string
}

const availableDicts = [
  'Settings',
  'AccessTable',
  'Events',
  'ReportsList',
  'Organizations',
  'EntUnits',
  'Roles',
  'Users',
  'Drivers',
  'DriverTasks',
  'ServiceNames',
  'Routes',
  'TransportType',
  'AutoService',
  'CarType',
  'CargoType',
  'Transport',
  'FuelType',
  'FuelFills',
  'DowntimeType',
  'Downtimes',
  'Repairs',
  'EPLFuel',
  'Signs',
  'EPLWorks',
  'CheckList',
  'CheckListLines',
  'SeasonControl',
  'EPL',
  'EPLjournal',
  'ActionJournal',
  'Glonass',
  'ADtoUIDlist',
  'ObjKS',
  'WorkSchedule',
  'GraphWork',
  'TransportShifts',
  'Calendar',
  'PassengerRoutes',
  'GalaxyReqList'
] as Array<string>

@Module({ dynamic: true, store, name: 'EPL' })
export default class EPLclass extends VuexModule implements EPL {
  public baseurl = baseURL
  public versionfg = '0.3'
  public versionbg = '?'
  public logstring = ''
  private driverFio = ''
  public user = {
    adid: 0,
    blocked: false,
    cardid: '',
    email: '',
    fio: '',
    id: 0,
    lastauth: 0,
    name: '',
    password: '',
    roleid: 0,
    token: '',
    tokenexpired: 0
  } as User

  public isAuth = true
  public loading = 0
  public dicts = [] as DictDataItem[]
  public lists = [] as DictList[]
  public queue = [] as Array<string>
  public errormessage = ''
  public cancel = [] as Array<any>

  private get TOKEN (): string {
    if (this.user.token === '') {
      const token: string | null = storeGet('Token')
      const expired: string | null = storeGet('Expired')
      if (token != null) this.user.token = token
      if (expired != null) this.user.tokenexpired = parseInt(expired)
    }
    return this.user.token
  }

  @Mutation
  setUser (user: User) {
    this.user = user
    storePut('Token', this.user.token)
    storePut('Expired', `${this.user.tokenexpired}`)
  }

  @Mutation
  setError (msg: string) {
    this.errormessage = msg
  }

  @Mutation
  setLogString (msg: string) {
    this.logstring = msg
  }

  @Mutation
  setVersionbg (version: string) {
    this.versionbg = version
  }

  @Mutation
  setDriverFio (fio: string) {
    this.driverFio = fio
  }

  get DriverFio () {
    return this.driverFio
  }

  @Mutation
  setBaseURL (url: string) {
    this.baseurl = url
  }

  @Mutation
  setTabn (tabn: string) {
    this.user.tabn = tabn
  }

  @Mutation
  clrLoading () {
    this.loading = 0
  }

  @Mutation
  upLoading () {
    this.loading++
  }

  @Mutation
  dnLoading () {
    setTimeout(() => {
      this.loading--
    }, 200)
  }

  @Action({ rawError: true })
  public async ClearAuth () {
    this.api({ url: '/api/logout', method: 'GET' })
      .then(() => {
        this.ErrorAuth()
      })
    this.setVersionbg('')
  }

  @Mutation
  SuccessAuth () {
    this.isAuth = true
  }

  @Mutation
  ErrorAuth () {
    this.isAuth = false
    this.user = {} as User
    this.user.token = ''
    storePut('Token', this.user.token)
  }

  @Action({ rawError: true })
  showDictForm (prop: { id: number, idx: number }) {
    // для корректного отображения текущего времени в форме
    if (this.dicts[prop.idx].formfields !== undefined) {
      this.dicts[prop.idx].formfields.forEach((tab: any) => {
        tab.data.forEach((e: any) => {
          switch (e.type) {
            case 'unixtime':
              this.dicts[prop.idx].defaultRow[e.value] = moment().unix()
              break
          }
        })
      })
    }
    if (prop.id === 0) {
      // если id 0, значит это новая запись
      this.dicts[prop.idx].currentRow = Object.assign(
        {},
        this.dicts[prop.idx].defaultRow
      )
    } else {
      this.dicts[prop.idx].rows.forEach((e: any) => {
        // найдём по id строку для редактирования
        if (e.id === prop.id) {
          // получить данные о подписании для блокировки подписанных полей
          if (e.eplid !== undefined) {
            this.blockSignedFields({ idx: prop.idx, eplid: e.eplid })
          }
          if (this.dicts[prop.idx].name === 'EPL') {
            this.blockSignedFields({ idx: prop.idx, eplid: e.id })
          }
          this.dicts[prop.idx].currentRow = Object.assign({}, e)
          this.dicts[prop.idx].formfields.forEach((tab: any) => {
            tab.data.forEach((t: any) => {
              // найдём поля с чипсами и сделаем массив
              if (t.type === 'multipleselect') {
                this.dicts[prop.idx].currentRow[t.value] = this.dicts[
                  prop.idx
                ].currentRow[t.value].split(',')
              }
            })
          })
        }
      })
    }
    this.dicts[prop.idx].isShowForm = true
  }

  @Mutation
  hideDictForm (idx: number) {
    this.dicts[idx].currentRow = Object.assign({}, this.dicts[idx].defaultRow)
    this.dicts[idx].isShowForm = false
  }

  public get DictIdx () {
    return (name: string): number => {
      let idx = -1
      this.dicts.forEach((d, i) => {
        if (d.name === name) idx = i
      })
      if (idx === -1) {
        // при отсутствии справочника создадим новый и запомним его индекс в массиве
        idx = this.dicts.push(new DictDataItem(name)) - 1
      }
      return idx
    }
  }

  get Dicts (): Array<DicListItem> {
    const dicts = [] as Array<DicListItem>
    this.dicts.forEach(d => {
      if (!d.locked.read) {
        const dli = {} as DicListItem
        dli.text = d.humanName
        dli.value = d.name
        dicts.push(dli)
      }
    })
    return dicts
  }

  @Action({ rawError: true })
  private api (param: {
    url: string,
    method: string,
    data?: string,
    formData?: FormData,
    auth?: AxiosBasicCredentials,
    responseType?: ResponseType
  }) {
    this.updateToken()
    return new Promise(
      (
        resolve: (value: AxiosResponse) => void,
        reject: (reason?: AxiosError | undefined) => void
      ) => {
        let loading = true
        if (param.url === '/api/dict/Events/rows') loading = false
        if (param.url.startsWith('/api/masspdfstatus')) loading = false
        if (loading) this.upLoading()
        const config = {} as AxiosRequestConfig
        let cancel: Canceler
        config.cancelToken = new Axios.CancelToken((c) => {
          this.cancel.push(c)
          cancel = c
        })
        config.url = this.baseurl + param.url
        config.method = param.method as Method
        config.headers = { 'Azot-Token': this.TOKEN }
        if (param.formData === undefined) {
          config.data = param.data
        } else {
          config.data = param.formData
          config.headers = { 'Azot-Token': this.TOKEN, 'Content-Type': 'multipart/form-data' }
        }
        config.auth = param.auth
        config.responseType = param.responseType
        Axios(config)
          .then(response => {
            if (loading) this.dnLoading()
            this.cancel.splice(this.cancel.indexOf(cancel), 1)
            resolve(response)
          })
          .catch((e: AxiosError) => {
            if (loading) this.dnLoading()
            this.cancel.splice(this.cancel.indexOf(cancel), 1)
            if (e.response !== undefined) {
              if (e.response.status === 401) {
                this.ErrorAuth()
              } else if (e.response.status === 429) {
                // превышено число попыток
              } else {
                if (e.response.status === 502) {
                  this.setError('Сервер недоступен!')
                } else {
                  if (e.response.config.responseType === 'arraybuffer') {
                    const ab = e.response.data as Uint16Array
                    const dec = new TextDecoder('utf-8')
                    this.setError(dec.decode(ab))
                  } else {
                    this.setError(e.response.data)
                  }
                }
              }
            }
            reject(e)
          })
      }
    )
  }

  @Action({ rawError: true })
  public cancelAll () {
    // отменить все ранее сделанные запросы к апи
    this.cancel.forEach(c => {
      if (c !== undefined) {
        c()
      }
    })
    this.cancel.splice(0, this.cancel.length)
  }

  @Action({ rawError: true })
  private updateToken () {
    // проверка истечения срока токена
    if (this.user.token === '') return
    if (this.user.tokenexpired + 60 < Date.now() / 1000) {
      // надо обновить
      Axios({
        url: '/api/tokenupdate',
        method: 'GET',
        headers: { 'Azot-Token': this.TOKEN }
      })
        .then(response => {
          this.setUser(response.data)
        })
        .catch(e => {
          console.log(e)
        })
    }
  }

  @Action({ rawError: true })
  public testLocalhost () {
    Axios({
      url: 'http://localhost:9999/',
      method: 'GET'
    })
      .then(response => {
        console.log(response)
      })
      .catch(e => {
        console.log(e)
      })
  }

  @Action({ rawError: true })
  public fetchUser (loginForm: LoginForm) {
    return new Promise((resolve, reject) => {
      this.api({
        url: '/api/auth',
        method: 'GET',
        auth: { username: loginForm.username, password: loginForm.passwd }
      })
        .then(async response => {
          this.setUser(response.data)
          await this.fetchAccessRight()
          await this.SuccessAuth()
          await this.fetchVersion()
          resolve(response)
        })
        .catch((e: AxiosError) => {
          reject(e)
        })
    })
  }

  @Action({ rawError: true })
  public fetchUserPost (loginForm: LoginForm) {
    return new Promise((resolve, reject) => {
      this.setLogString('Ожидание ' + this.baseurl)
      this.api({
        url: '/api/',
        method: 'GET'
      })
        .then(response => {
          const r = response.data as string
          if (r.indexOf('AZOT EPL HTTP service ready.') !== -1) {
            this.setLogString('Проверка пользователя')
            this.api({
              url: '/api/auth',
              method: 'POST',
              data: JSON.stringify(loginForm)
            })
              .then(async response => {
                this.setUser(response.data)
                await this.fetchAccessRight()
                await this.SuccessAuth()
                await this.fetchVersion()
                this.setLogString('')
                resolve(response)
              })
              .catch((e: AxiosError) => {
                reject(e)
              })
          } else {
            this.setError(`Сервер ${this.baseurl} не доступен`)
            reject(new Error())
          }
        })
    })
  }

  @Action({ rawError: true })
  private fetchVersion (): void {
    this.api({ url: '/api/version', method: 'GET' }).then(response => {
      this.setVersionbg(response.data)
    })
  }

  @Action({ rawError: true })
  public fetchWhoInfo () {
    return new Promise<{companyname: string, logo: string}>((resolve, reject) => {
      this.api({ url: '/api/who', method: 'GET' })
        .then(async response => {
          resolve(response.data)
        })
        .catch((e: AxiosError) => {
          reject(e)
        })
    })
  }

  @Action({ rawError: true })
  public fetchUserInfo () {
    return new Promise<void>((resolve, reject) => {
      if (this.TOKEN === '') {
        console.log('bad token')
      }
      this.setLogString('Ожидание ' + this.baseurl)
      this.api({
        url: '/api/',
        method: 'GET'
      })
        .then(response => {
          const r = response.data as string
          if (r.indexOf('AZOT EPL HTTP service ready.') !== -1) {
            this.setLogString('Получение профиля')
            this.api({ url: '/api/profile', method: 'GET' })
              .then(async response => {
                this.setUser(response.data)
                await this.fetchAccessRight()
                await this.SuccessAuth()
                await this.fetchVersion()
                this.setLogString('Получение профиля')
                resolve()
              })
              .catch((e: AxiosError) => {
                reject(e)
              })
          } else {
            this.setError(`Сервер ${this.baseurl} не доступен`)
            reject(new Error())
          }
        })
    })
  }

  @Action({ rawError: true })
  private async fetchAccessRight () {
    const names = [] as Array<string>
    await this.api({
      url: '/api/dict/ALL/list',
      method: 'POST',
      data: '{"text":"","value":""}'
    })
      .then(response => {
        if (response.data !== null) {
          response.data.forEach(async (d: any) => {
            names[d.value] = d.text
          })
        }
      })
    return new Promise<void>(resolve => {
      this.dicts.splice(0, this.dicts.length)
      if (this.user.roleid === 1) {
        availableDicts.forEach(async (ad: any) => {
          // просматриваем доступные справочники
          // добавляем права для доступных справочников
          const idx = this.DictIdx(ad)
          this.dicts[idx].humanName = names[ad]
          if (ad === 'ActionJournal') {
            this.dicts[idx].locked.fields = ''
            this.dicts[idx].locked.add = true
            this.dicts[idx].locked.read = false
            this.dicts[idx].locked.upd = true
            this.dicts[idx].locked.del = true
          } else {
            this.dicts[idx].locked.fields = ''
            this.dicts[idx].locked.add = false
            this.dicts[idx].locked.read = false
            this.dicts[idx].locked.upd = false
            this.dicts[idx].locked.del = false
          }
        })
        resolve()
      } else {
        const request = {} as DictRequest
        request.options = { page: 1, itemsPerPage: 100 }
        request.filter = []
        request.filter.push({
          field: 'roleid',
          condition: `${this.user.roleid}`,
          operator: '=',
          combine: 'AND'
        })
        request.filter.push({
          field: 'crud',
          condition: '%R%',
          operator: 'LIKE',
          combine: 'AND'
        })
        this.api({
          url: '/api/dict/AccessTable/rows',
          method: 'PATCH',
          data: JSON.stringify(request)
        }).then(response => {
          if (response.data !== null) {
            availableDicts.forEach((ad: any) => {
              // просматриваем доступные справочники
              response.data.forEach(async (d: any) => {
                if (ad === d.dictname) {
                  // добавляем права для доступных справочников
                  const idx = this.DictIdx(d.dictname)
                  this.dicts[idx].humanName = names[d.dictname]
                  this.dicts[idx].locked.fields = d.fields
                  const crud = d.crud.toLowerCase()
                  if (crud.indexOf('c') >= 0) {
                    this.dicts[idx].locked.add = false
                  }
                  if (crud.indexOf('r') >= 0) {
                    this.dicts[idx].locked.read = false
                  }
                  if (crud.indexOf('u') >= 0) {
                    this.dicts[idx].locked.upd = false
                  }
                  if (crud.indexOf('d') >= 0) {
                    this.dicts[idx].locked.del = false
                  }
                }
              })
            })
          }
          resolve()
        })
      }
    })
  }

  @Action({ rawError: true })
  private setDefaultValue (param: { idx: number, elem: any }) {
    if (param.elem.default === undefined) {
      switch (param.elem.type) {
        case 'float':
        case 'number':
        case 'unixtime':
          this.dicts[param.idx].defaultRow[param.elem.value] = 0
          break
        case 'switch':
          this.dicts[param.idx].defaultRow[param.elem.value] = false
          break
        case 'select':
          if (param.elem.sourcetype === 'number') {
            this.dicts[param.idx].defaultRow[param.elem.value] = 0
          } else {
            this.dicts[param.idx].defaultRow[param.elem.value] = ''
          }
          break
        case 'textarea':
        case 'password':
        default:
          this.dicts[param.idx].defaultRow[param.elem.value] = ''
          break
      }
    } else {
      this.dicts[param.idx].defaultRow[param.elem.value] = param.elem.default
    }
  }

  @Action({ rawError: true })
  private makeDefaultRow (idx: number) {
    this.dicts[idx].defaultRow = {}
    this.dicts[idx].defaultRow.id = 0
    // if (this.dicts[idx].rows.length === 0) {
    this.dicts[idx].formfields.forEach((tab: any) => {
      tab.data.forEach((e: any) => {
        if (e.type === 'card') {
          e.data.forEach((c: any) => {
            this.setDefaultValue({ idx: idx, elem: c })
          })
        } else {
          this.setDefaultValue({ idx: idx, elem: e })
        }
      })
    })
    this.dicts[idx].defaultRow.id = 0
    // } else {
    //   // дефолтный row для корректной работы валидации полей формы при добавления нового
    //   for (const key in this.dicts[idx].rows[0]) {
    //     const t = typeof this.dicts[idx].rows[0][key]
    //     switch (t) {
    //       case 'string':
    //         this.dicts[idx].defaultRow[key] = ''
    //         break
    //       case 'number':
    //         this.dicts[idx].defaultRow[key] = 0
    //         break
    //       case 'boolean':
    //         this.dicts[idx].defaultRow[key] = false
    //         break
    //     }
    //   }
    // }
  }

  @Action({ rawError: true })
  private fetchLists (param: { idx: number, noLists?: boolean }) {
    return new Promise<void>(resolve => {
      if (param.noLists !== true) {
        this.queue.splice(0, this.queue.length)
        const pr = [] as any
        this.dicts[param.idx].headers.forEach((e: any) => {
          if (e.type !== undefined) {
            if (e.type.indexOf('select') === 0) {
              // для типа select нужно получить поля из другого справочника
              pr.push(this.correctListType({ e: e, idx: param.idx }))
            }
          }
        })
        let fields = this.dicts[param.idx].formfields
        if (this.dicts[param.idx].name === 'EPL') {
          fields = this.dicts[param.idx].EPLfields
        }
        fields.forEach((tab: any) => {
          tab.data.forEach((e: any) => {
            if (e.type !== undefined) {
              if (e.type.indexOf('select') === 0) {
                // для типа select нужно получить поля из другого справочника
                pr.push(this.correctListType({ e: e, idx: param.idx }))
              }
              if (e.type === 'card') {
                // у типа card есть вложенные поля
                e.data.forEach((f: any) => {
                  if (f.type !== undefined) {
                    if (f.type.indexOf('select') === 0) {
                      pr.push(this.correctListType({ e: f, idx: param.idx }))
                    }
                  }
                })
              }
            }
          })
        })
        Promise.all(pr).then(() => {
          // дождёмся составления всех списков
          resolve()
        })
      } else resolve()
    })
  }

  @Action({ rawError: true })
  // получение данных для отображения таблиц и форм
  private fetchDictHeaders (idx: number) {
    return new Promise<void>(resolve => {
      if (this.dicts[idx].headers.length === 0) {
        // получаем заголовки для интерфейса
        this.api({
          url: '/api/dict/' + this.dicts[idx].name + '/headers',
          method: 'GET'
        }).then(response => {
          response.data.headers.push({ text: '', value: 'action', width: '50', type: 'action', sortable: false })
          this.dicts[idx].headers = response.data.headers.map((item: any) => Object.freeze(item))
          this.dicts[idx].fields = Object.freeze(response.data.fields)
          if (response.data.EPLfields !== undefined) {
            this.dicts[idx].EPLfields = response.data.EPLfields.map((item: any) => Object.freeze(item))
          }
          this.dicts[idx].formfields = response.data.formfields.map((item: any) => Object.freeze(item))
          this.makeDefaultRow(idx)
          this.dicts[idx].currentRow = Object.assign(
            {},
            this.dicts[idx].defaultRow
          )
          resolve()
        })
      } else resolve()
    })
  }

  @Action({ rawError: true })
  public fetchDictData (param: DictParam) {
    return new Promise<void>(resolve => {
      this.dicts[param.idx].rows.splice(
        0,
        this.dicts[param.idx].rows.length
      )
      this.fetchDictHeaders(param.idx).then(() => {
        this.fetchLists({ idx: param.idx, noLists: param.noLists }).then(() => {
          this.api({
            url: '/api/dict/' + this.dicts[param.idx].name + '/rows',
            method: 'PATCH',
            data: JSON.stringify(param.request)
          }).then(async response => {
            this.dicts[param.idx].rowsCount = parseInt(
              response.headers['total-rows']
            )
            if (response.data !== null) {
              if (this.dicts[param.idx].name === 'ActionJournal') {
                // костыль для отображения русских названий полей в изменениях
                response.data.forEach((r: any) => {
                  r.value = `${r.value}~~~${r.tablename}`
                })
              }
              // если это реестр ПЛ, нужно получить подписи для них
              if (this.dicts[param.idx].name === 'EPL') {
                // нужно получить подписи для отображаемых ЭПЛ
                const vals = [] as Array<string>
                response.data.forEach((e: any) => {
                  vals.push(e.id)
                })
                let cond = JSON.stringify(vals)
                cond = cond.replace(/"/g, '\'')
                cond = cond.replace('[', '(')
                cond = cond.replace(']', ')')
                const ps = {} as DictParam
                ps.idx = this.DictIdx('Signs')
                ps.request = {} as DictRequest
                ps.request.options = { page: 1, itemsPerPage: -1 }
                ps.request.filter = []
                const fs = {} as DictFilter
                fs.field = 'eplid'
                fs.condition = cond
                fs.operator = 'IN'
                ps.request.filter.push(fs)
                await this.fetchDictData(ps)
              }
              // -------------
            }
            if (response.data !== null) {
              const hdr = this.dicts[param.idx].headers
              if (hdr !== undefined) {
                for (let h = 0; h < hdr.length; h++) {
                  for (let r = 0; r < response.data.length; r++) {
                    if (hdr[h].type === 'switch') {
                      if (response.data[r][hdr[h].value] > 1) {
                        response.data[r][`${hdr[h].value}-f`] = moment.unix(response.data[r][hdr[h].value]).format('HH:mm')
                      } else {
                        response.data[r][`${hdr[h].value}-f`] = ''
                      }
                    }
                    if (hdr[h].type === 'unixtime') {
                      if (response.data[r][hdr[h].value] === 0) {
                        response.data[r][`${hdr[h].value}-f`] = '-'
                      } else {
                        response.data[r][`${hdr[h].value}-f`] = moment.unix(response.data[r][hdr[h].value]).format('DD.MM.YYYY HH:mm')
                      }
                    }
                    if (hdr[h].type === 'time') {
                      if (hdr[h].value === 'worktime' && response.data[r][hdr[h].value] === 0) {
                        response.data[r][`${hdr[h].value}-f`] = ''
                      } else {
                        const hr = Math.trunc(response.data[r][hdr[h].value] / 60)
                        const mn = response.data[r][hdr[h].value] - hr * 60
                        let ht = `${hr}`
                        if (hr < 10) ht = '0' + hr
                        let mt = `${mn}`
                        if (mn < 10) mt = '0' + mn
                        response.data[r][`${hdr[h].value}-f`] = `${ht}:${mt}`
                      }
                    }
                    if (hdr[h].type === 'unixdate') {
                      if (response.data[r][hdr[h].value] === 0) {
                        response.data[r][`${hdr[h].value}-f`] = '-'
                      } else {
                        response.data[r][`${hdr[h].value}-f`] = moment.unix(response.data[r][hdr[h].value]).format('DD.MM.YYYY')
                      }
                    }
                    if (hdr[h].type === 'select') {
                      const l = this.lists[`${hdr[h].source}-${hdr[h].sourcetext}` as any]
                      if (l === undefined) {
                        // console.log(`${hdr[h].source}-${hdr[h].sourcetext}`)
                      } else {
                        const value = response.data[r][hdr[h].value]
                        let result = ''
                        for (let i = 0; i < l.length; i++) {
                          if (l[i].value === value || l[i].value === `${value}`) {
                            result = l[i].text
                            break
                          }
                        }
                        response.data[r][`${hdr[h].sourcetext}${hdr[h].value}-f`] = result
                        // console.log(`${hdr[h].sourcetext}${hdr[h].value}-f`, result)
                      }
                    }
                  }
                }
              }
              this.dicts[param.idx].rows = response.data // .map((item: any) => Object.freeze(item))
            }
            // if (this.dicts[param.idx].headers.length === 0) {
            //   await this.fetchDictHeaders(param.idx)
            // }
            // if (param.noLists !== true) {
            //   await this.fetchLists(param.idx)
            // }
            resolve()
          })
        })
      })
    })
  }

  @Action({ rawError: true })
  public downloadJournal (param: DictParam) {
    return new Promise(resolve => {
      this.api({
        url: '/api/journalfile',
        method: 'POST',
        data: JSON.stringify(param.request),
        responseType: 'arraybuffer'
      }).then(async response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async getJournal (prop: { type: string, id: number }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/journalfile/${prop.type}/${prop.id}`,
        method: 'POST',
        responseType: 'arraybuffer'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public newJournal (param: { id: number, data: string }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/journalfile/new/${param.id}`,
        method: 'POST',
        data: param.data,
        responseType: 'arraybuffer'
      }).then(async response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public addJournal (param: { id: number, data: string }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/journalfile/${param.id}`,
        method: 'POST',
        data: param.data
      }).then(async response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public blockSignedFields (param: { idx: number, eplid: number }) {
    return new Promise<void>(resolve => {
      // для этих справочников необходимо заблокировать подписанные поля
      // console.log(this.dicts[param.idx].name, 'epl:', param.eplid)
      let signs = [] as any
      let access = [] as any
      const pa = [] as Array<Promise<any>>
      // проставленные подписи
      const rs = {} as DictRequest
      rs.options = { page: 1, itemsPerPage: -1 }
      rs.filter = []
      rs.filter.push({
        field: 'eplid',
        condition: `${param.eplid}`,
        operator: '=',
        combine: 'AND'
      })
      pa.push(this.api({
        url: '/api/dict/Signs/rows',
        method: 'PATCH',
        data: JSON.stringify(rs)
      })
        .then(response => {
          if (response.data !== null) {
            signs = response.data
          }
        }))
      // списки блокируемых полей
      const rf = {} as DictRequest
      rf.options = { page: 1, itemsPerPage: -1 }
      rf.filter = []
      rf.filter.push({
        field: 'dictname',
        condition: `${this.dicts[param.idx].name}`,
        operator: '=',
        combine: 'AND'
      })
      pa.push(this.api({
        url: '/api/dict/AccessTable/rows',
        method: 'PATCH',
        data: JSON.stringify(rf)
      })
        .then(response => {
          if (response.data !== null) {
            access = response.data
          }
        }))
      Promise.all(pa).then(() => {
        this.dicts[param.idx].signedFields = ''
        access.forEach((a: any) => {
          signs.forEach((s: any) => {
            if (a.roleid === s.role) {
              if (s.eventtype === 0) {
                if (a.departure !== '') {
                  this.dicts[param.idx].signedFields += a.departure
                  this.dicts[param.idx].signedFields += ','
                }
              }
              if (s.eventtype === 1) {
                if (a.arrived !== '') {
                  this.dicts[param.idx].signedFields += a.arrived
                  this.dicts[param.idx].signedFields += ';'
                }
              }
            }
          })
        })
        // если ПЛ подписан PDF диспетчером, то запрещаем добавлять в него записи
        const idx = this.DictIdx('EPL')
        this.dicts[idx].rows.forEach(r => {
          if (r.id === param.eplid) {
            if (r.signed > 0) this.dicts[param.idx].signedFields += ';'
          }
        })
        resolve()
      })
    })
  }

  @Action({ rawError: true })
  private correctListType (prop: { e: any, idx: number }) {
    return new Promise<void>(resolve => {
      let listName = `${prop.e.source}-${prop.e.sourcetext}` as any
      if (prop.idx < 0) {
        listName = 'HEADERS-HEADERS'
      }
      if (prop.e.source === 'CUTUNITS') {
        listName = 'CUTUNITS-CUTUNITS'
      }
      if (prop.e.source === 'DRIVERORG') {
        listName = 'DRIVERORG-DRIVERORG'
      }
      // поиск в созданных списках или в очереди создания
      if (
        listName === 'UsersDrivers-name' ||
        listName === 'HEADERS-HEADERS' ||
        (this.lists[listName] === undefined &&
          this.queue.indexOf(listName) === -1)
      ) {
        // надо создать новый
        // console.log(listName)
        this.queue.push(listName)
        this.api({
          url: `/api/dict/${prop.e.source}/list/${prop.e.sourcetext}/${prop.e.sourcevalue}`,
          method: 'GET'
        }).then(response => {
          // поля string для коррекной работы при необходимости преобразуем в number
          if (response.data !== null) {
            if (prop.idx >= 0) {
              let valueType = ''
              this.dicts[prop.idx].headers.forEach((h: any) => {
                if (prop.e.value === h.value) {
                  valueType = h.sourcetype
                }
              })
              let fields = this.dicts[prop.idx].formfields
              if (this.dicts[prop.idx].name === 'EPL') {
                fields = this.dicts[prop.idx].EPLfields
              }
              fields.forEach((tab: any) => {
                tab.data.forEach((i: any) => {
                  if (i.type === 'card') {
                    i.data.forEach((c: any) => {
                      if (prop.e.value === c.value) {
                        valueType = c.sourcetype
                      }
                    })
                  }
                  if (prop.e.value === i.value) {
                    valueType = i.sourcetype
                  }
                })
              })
              if (valueType === 'number') {
                response.data.forEach((v: any) => {
                  v.value = parseFloat(v.value)
                })
              }
            }
            this.lists[listName] = response.data.map((item: any) => Object.freeze(item)) as DictList
          } else {
            this.lists[listName] = [] as DictList
          }
          resolve()
        })
      } else {
        resolve()
      }
    })
  }

  @Action({ rawError: true })
  public fetchHeadersList (dict: string) {
    return new Promise<void>(resolve => {
      const e = { source: dict, sourcetext: 'HEADERS', sourcevalue: 'HEADERS' }
      this.correctListType({ e: e, idx: -1 }).then(() => resolve())
    })
  }

  @Action({ rawError: true })
  public fetchList (prop: { dict: string, sourcetext: string, sourcevalue: string }) {
    return new Promise<void>(resolve => {
      const e = { source: prop.dict, sourcetext: prop.sourcetext, sourcevalue: prop.sourcevalue }
      this.correctListType({ e: e, idx: -1 }).then(() => resolve())
    })
  }

  @Action({ rawError: true })
  public saveDictRow (prop: { id: number, idx: number }) {
    let data = ''
    this.dicts[prop.idx].rows.forEach((e: any) => {
      if (e.id === prop.id) {
        data = JSON.stringify(e)
      }
    })
    this.api({
      url: '/api/dict/' + this.dicts[prop.idx].name + '/',
      method: 'PUT',
      data: data
    })
  }

  @Action({ rawError: true })
  public delDictRow (prop: { id: number, idx: number }) {
    return new Promise<void>(resolve => {
      this.api({
        url: '/api/dict/' + this.dicts[prop.idx].name + '/' + prop.id,
        method: 'DELETE'
      }).then(() => {
        let index = 0
        this.dicts[prop.idx].rows.forEach((e: any, i: number) => {
          if (e.id === prop.id) {
            index = i
          }
        })
        this.dicts[prop.idx].rows.splice(index, 1)
        this.dicts[prop.idx].rowsCount--
        this.dicts[prop.idx].currentRow = Object.assign(
          {},
          this.dicts[prop.idx].defaultRow
        )
        resolve()
      })
    })
  }

  @Action({ rawError: true })
  public saveDictCurrentRow (prop: { idx: number, hide: boolean }) {
    return new Promise<void>(resolve => {
      let method: Method
      if (this.dicts[prop.idx].currentRow.id === 0) {
        method = 'POST'
      } else {
        method = 'PUT'
      }
      this.dicts[prop.idx].formfields.forEach((tab: any) => {
        tab.data.forEach((t: any) => {
          // найдём поля с паролем и зашифруем
          if (t.type === 'password') {
            const pw = this.dicts[prop.idx].currentRow[t.value]
            if (pw !== '') {
              const hash = CryptoJS.SHA1(pw)
              const hexhash = CryptoJS.enc.Hex.stringify(hash)
              this.dicts[prop.idx].currentRow[t.value] = hexhash
            }
          }
          // пустое время должно отдавать 0
          if (t.type === 'time') {
            if (this.dicts[prop.idx].currentRow[t.value] === '') {
              this.dicts[prop.idx].currentRow[t.value] = 0
            }
          }
          // найдём поля с чипсами и слепим их в строку
          if (t.type === 'multipleselect') {
            const si = this.dicts[prop.idx].currentRow[t.value]
            if (si.length > 0) {
              let res = ''
              si.forEach((i: any) => {
                if (i !== '') res += `${i},`
              })
              this.dicts[prop.idx].currentRow[t.value] = res.substring(
                0,
                res.length - 1
              )
            } else {
              this.dicts[prop.idx].currentRow[t.value] = ''
            }
          }
        })
      })
      this.api({
        url: '/api/dict/' + this.dicts[prop.idx].name + '/',
        method: method,
        data: JSON.stringify(this.dicts[prop.idx].currentRow)
      }).then((response) => {
        if (this.dicts[prop.idx].currentRow.id === 0) {
          // была добавлена новая строка
          this.dicts[prop.idx].rowsCount++
          this.dicts[prop.idx].rows.push(response.data)
          if (this.dicts[prop.idx].rowsCount === 1) {
            this.makeDefaultRow(prop.idx)
          }
        } else {
          // обновим старую
          this.dicts[prop.idx].rows.forEach((e: any, i: number) => {
            // найдём по id строку для обновления
            if (e.id === this.dicts[prop.idx].currentRow.id) {
              Object.assign(
                this.dicts[prop.idx].rows[i],
                this.dicts[prop.idx].currentRow
                // response.data
              )
            }
          })
        }
        if (prop.hide) this.hideDictForm(prop.idx)
        resolve()
      })
    })
  }

  @Action({ rawError: true })
  public async clearEvents () {
    const idx = this.DictIdx('Events')
    this.api({ url: '/api/eventsread', method: 'GET' }).then(() => {
      this.dicts[idx].rows.splice(0, this.dicts[idx].rows.length)
      this.dicts[idx].rowsCount = 0
    })
  }

  @Action({ rawError: true })
  public async makeCalendar (prop: { beg: number, end: number }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/calendar/${prop.beg}/${prop.end}`,
        method: 'GET'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async readEPLMessage (data: string) {
    this.api({
      url: '/api/dict/Events/',
      method: 'PUT',
      data: data
    })
  }

  @Action({ rawError: true })
  public async getEPLMessage (filter: string) {
    return new Promise(resolve => {
      this.api({
        url: '/api/dict/Events/rows',
        method: 'PATCH',
        data: filter
      }).then(response => resolve(response.data))
    })
  }

  @Action({ rawError: true })
  public async sendEPLMessage (msg: string) {
    return new Promise(resolve => {
      this.api({
        url: '/api/dict/Events/',
        method: 'POST',
        data: msg
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async makeCalendarEx (prop: { beg: number, end: number, tc: Array<string> }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/calendar/${prop.beg}/${prop.end}`,
        method: 'POST',
        data: JSON.stringify(prop.tc)
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async delEPL (prop: { beg: number, end: number }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/delepl/${prop.beg}/${prop.end}`,
        method: 'GET'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async clrCalendar (prop: { beg: number, end: number }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/calendarclr/${prop.beg}/${prop.end}`,
        method: 'GET'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async clrCalendarEx (prop: { beg: number, end: number, tc: Array<string> }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/calendarclr/${prop.beg}/${prop.end}`,
        method: 'POST',
        data: JSON.stringify(prop.tc)
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async galaxySend (prop: { beg: number, end: number }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/galaxysend/${prop.beg}/${prop.end}`,
        method: 'GET'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async dictFindField (prop: { dict: string, field: string, byfield: string, value: string }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/dict/${prop.dict}/find/${prop.field}/${prop.byfield}/${prop.value}`,
        method: 'GET'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async massGlonass (prop: { beg: number }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/massglonass/${prop.beg}`,
        method: 'GET'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async downloadPDF (id: number) {
    return new Promise(resolve => {
      this.api({
        url: `/api/pdf/${id}`,
        method: 'GET',
        responseType: 'arraybuffer'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async downloadPDFblank (id: number) {
    return new Promise(resolve => {
      this.api({
        url: `/api/pdf/${id}/blank`,
        method: 'GET',
        responseType: 'arraybuffer'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async getPDFURL (id: number) {
    return new Promise(resolve => {
      this.api({
        url: `/api/getpdfurl/${id}`,
        method: 'GET'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async downloadSigPDF (id: number) {
    return new Promise(resolve => {
      this.api({
        url: `/api/getsignedpdf/${id}`,
        method: 'GET',
        responseType: 'arraybuffer'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async getReport (prop: { id: number, param: DictRequest }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/report/${prop.id}`,
        method: 'POST',
        responseType: 'arraybuffer',
        data: JSON.stringify(prop.param)
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async getArchEPL (prop: { beg: number, end: number, transport: string }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/getarchive/${prop.beg}/${prop.end}/${prop.transport}`,
        method: 'GET',
        responseType: 'arraybuffer'
      }).then(response => resolve(response))
    })
  }

  @Action({ rawError: true })
  public async setSignPDFFile (prop: { id: number, data: string, name: string }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append('file', new Blob([prop.data]), prop.name)
      this.api({
        url: `/api/uploadsignedpdf/${prop.id}`,
        method: 'POST',
        formData: formData
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async getSignXMLFile (prop: { id: number, event: number, role: number }) {
    return new Promise(resolve => {
      this.api({
        url: `/api/signfile/${prop.id}/${prop.event}/${prop.role}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async getTaskXMLFile (id: number) {
    return new Promise(resolve => {
      this.api({
        url: `/api/signtaskxml/${id}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async getSignTaskXMLFile (id: number) {
    return new Promise(resolve => {
      this.api({
        url: `/api/signtaskfile/${id}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async setSignXMLFile (prop: { id: number, event: number, cert: string, data: string }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append('file', new Blob([prop.data]))
      formData.append('filecode', prop.cert)
      this.api({
        url: `/api/uploadsign/${prop.id}/${prop.event}`,
        method: 'POST',
        formData: formData
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async setSignTaskXMLFile (prop: { id: number, data: string }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append('file', new Blob([prop.data]))
      this.api({
        url: `/api/signtask/ds/${prop.id}`,
        method: 'POST',
        formData: formData
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async setSignJournalFile (prop: { data: string, name: string }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append('file', new Blob([prop.data]), prop.name)
      this.api({
        url: '/api/journalsign',
        method: 'POST',
        formData: formData
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async signJournal (prop: { id: number, cert: string, data: string, name: string }) {
    return new Promise(resolve => {
      const formData = new FormData()
      formData.append('file', new Blob([prop.data]), prop.name)
      formData.append('filecode', prop.cert)
      this.api({
        url: `/api/journalsign/${prop.id}`,
        method: 'POST',
        formData: formData
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public async setSignSimple (prop: { id: number, event: number, login: string, password: string }) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/simplesign/${prop.id}/${prop.event}`,
        method: 'POST',
        data: `{"tabel":${prop.login},"token":"${CryptoJS.SHA1(prop.password)}"}`
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public async setSignTaskIDO (prop: { id: number, login: string, password: string }) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/signtask/ido/${prop.id}`,
        method: 'POST',
        data: `{"tabel":${prop.login},"token":"${CryptoJS.SHA1(prop.password)}"}`
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public async setSignTaskNFC (prop: { id: number, login: string, password: string }) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/signtask/nfc/${prop.id}`,
        method: 'POST',
        data: `{"tabel":null,"token":"${prop.password}"}`
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public async getLatLon (address: string) {
    return new Promise((resolve, reject) => {
      this.api({
        url: '/api/getlatlon',
        method: 'POST',
        data: address
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public async getAskData (prop: { id: number, type: string, p1?: string, p2?: string }) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/${prop.type}/${prop.id}/${prop.p1}/${prop.p2}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public async getHistoryRoute (prop: { begin: number, end: number, transport: number }) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/gethistoryroute/${prop.begin}/${prop.end}/${prop.transport}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public getAzotNavi (latlngs: string) {
    return new Promise(resolve => {
      this.api({
        url: `/api/osrm/${latlngs}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public getPrevEPL (param: { id: string, uid: number, time: number }) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/prevepl/${param.id}/${param.uid}/${param.time}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      }).catch(e => {
        reject(e)
      })
    })
  }

  @Action({ rawError: true })
  public syncGalaxyDic () {
    return new Promise(resolve => {
      this.api({
        url: '/api/sync',
        method: 'GET'
      }).then(response => {
        resolve(response)
      })
    })
  }

  @Action({ rawError: true })
  public eplToGalaxy (id: number) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/epltogalaxy/${id}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  public eplToGalaxyDirect (param: { from: number, to: number }) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/galaxysenddirect/${param.from}/${param.to}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      }).catch(e => { reject(e) })
    })
  }

  @Action({ rawError: true })
  public massPdfResult (token: string) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/masspdfresult/${token}`,
        method: 'GET',
        responseType: 'arraybuffer'
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public massPdfStatus (token: string) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/masspdfstatus/${token}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public massPdf (id: Array<number>) {
    return new Promise((resolve, reject) => {
      this.api({
        url: '/api/masspdf',
        method: 'POST',
        data: JSON.stringify(id)
      }).then(response => {
        resolve(response.data)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public massPdfBlank (id: Array<number>) {
    return new Promise((resolve, reject) => {
      this.api({
        url: '/api/masspdf/blank',
        method: 'POST',
        data: JSON.stringify(id)
      }).then(response => {
        resolve(response.data)
      }).catch((e) => reject(e))
    })
  }

  @Action({ rawError: true })
  public updmileage (id: number) {
    return new Promise((resolve, reject) => {
      this.api({
        url: `/api/updmileage/${id}`,
        method: 'GET'
      }).then(response => {
        resolve(response)
      }).catch((e) => reject(e))
    })
  }
}

export const EPLModule = getModule(EPLclass)
